import { createFileRoute } from '@tanstack/react-router'
import MyCompanyPage from "../../components/MyCompany/MyCompanyPage.tsx";

export const Route = createFileRoute('/_layout/my-company')({
  component: MyCompanyPage,
})

